<template>
  <header>
    <h1>
      USPS Change-of-Address<sup>®</sup>
    </h1>
  </header>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style scoped>
header {
  margin: 0 0 0 20px;
}
h1 {
  font-family: "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
}
</style>
